function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useContext, useMemo, useState } from 'react';
var defaultValue = {
    open: false,
    message: '',
    severityValue: '',
    setMessage: function setMessage() { },
    setSeverityValue: function setSeverityValue() { },
    setToastState: function setToastState() { }
};
var ToastContext = /*#__PURE__*/ React.createContext(defaultValue);
export var ToastContextProvider = function ToastContextProvider(_ref) {
    var children = _ref.children;
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), msg = _useState4[0], setMsg = _useState4[1];
    var _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), severityValue = _useState6[0], setSeverityValue = _useState6[1];
    var stateHandler = function stateHandler(v) {
        setIsOpen(v);
    };
    var contextValue = useMemo(function () {
        return {
            open: isOpen,
            message: msg,
            severityValue: severityValue,
            setSeverityValue: setSeverityValue,
            setMessage: setMsg,
            setToastState: stateHandler
        };
    }, [isOpen, msg, severityValue]);
    return /*#__PURE__*/ React.createElement(ToastContext.Provider, {
        value: contextValue
    }, children);
};
export var useToastContext = function useToastContext() {
    return useContext(ToastContext);
};
export default ToastContext;
